//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
SPLM.ValidatorVersion = Object.freeze({
    "Zero" : "Zero", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five"});

SPLM.ValidatorPrintLevel = Object.freeze({
    "Light" : "Light", "Heavy" : "Heavy", "Full" : "Full"});

export default SPLM;